const assert = require('helpbox/source/assert');
let Callcise;
function evaluate(that, parameters) {
    return parameters.map(parameter => {
        return parameter.call(that);
    });
}
function self(propertyName) {
    return function getOwnProperty() {
        assert(propertyName in this, `No such property: ${propertyName}`);
        return this[propertyName];
    };
}
function lambda(f, ...parameters) {
    return function callAnyFunction(...additionalParameters) {
        return f.apply(this, evaluate(this, parameters).concat(additionalParameters));
    };
}
function method(name, ...parameters) {
    return function callΜethod(...additionalParameters) {
        return this[name](...evaluate(this, parameters).concat(additionalParameters));
    };
}
function plugin(Plugin) {
    Object.assign(Callcise, Plugin);
}
Callcise = {
    internal: { evaluate },
    plugin,
    lambda,
    method,
    self
};
module.exports = Callcise;
